let windowWidth: number

export default (): number => {
  if (!windowWidth) {
    windowWidth = window.innerWidth
  }
  return windowWidth
}
